import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react'

import { Provider, createClient } from 'wagmi'
import { InjectedConnector } from 'wagmi/connectors/injected'

// Set up connectors
const client = createClient({
  autoConnect: true,
  connectors() {
    return [
      new InjectedConnector(),
    ]
  },
})



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <Provider client={client}>
      <App />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>
);
